module.exports = __webpack_public_path__ + "static/financial-information-hero-mobile.9b2754ca.webp";